import { Component, OnInit } from "@angular/core";
import { User } from "src/app/models/Identity/user";
import { AuthenticationService } from "../../services/authentication.service";

@Component({
  selector: "app-not-authorized",
  templateUrl: "./not-authorized.component.html",
  styleUrls: ["./not-authorized.component.css"],
})
export class NotAuthorizedComponent implements OnInit {
  public userLogged: User = new User();
  constructor(private authInternalService: AuthenticationService) {}
  ngOnInit(): void {
    this.authInternalService.userObservable.subscribe(u => {
      this.userLogged = u;
    });
  }
  public onClick() {
    this.authInternalService.logout();
  }
}
